import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { readVarM } from '../Assertions/environments';
import { T } from '../Translations';

const CallToAction: React.FC = () => {
  return readVarM('VITE_UNIFIED_LOGIN_URL')
    .andThen(fromEmpty)
    .map((url) => (
      <a
        className={clsx(
          'inline-block cursor-pointer whitespace-nowrap text-center',
          'rounded-sm border-solid border-transparent py-2 px-4 font-light tracking-wide',
          'w-full bg-green-600 text-sm text-white hover:bg-gray-500',
        )}
        data-intercom-target="client-portal-login-button"
        href={url}
      >
        <T kind="Sign In via Learning Platform" />
      </a>
    ))
    .getOrElse(() => (
      <p style={{ color: 'red', fontWeight: 'bold' }}>
        <T kind="Error: The app is misconfigured." />
      </p>
    ));
};

export default observer(CallToAction);
